module.exports = __webpack_public_path__ + "img/52.11fb22ca.jpg";